import React, { useEffect } from 'react'

import { Row, Col } from 'antd'
import { map, get, flatten } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'

import { SearchItem } from '../components'
import { getSearch } from '../redux/actions/search'
import ArticleLayout from '../templates/Article'
// import { numberWithCommas } from '../utils'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const SearchResult = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const query = useQuery()

  const handleOnClick = (slug) => {
    history.push(`/category/${slug}`)
  }

  const searchtext = query.get('searchtext')

  useEffect(() => {
    dispatch(getSearch(i18n.language, searchtext))
  }, [i18n.language, searchtext])

  const [commonContent, searchContent] = useSelector((state) => [
    get(state, 'common.data', {}),
    get(state, 'search.data', {}),
  ])
  console.log('searchContent: ', flatten(searchContent))
  return (
    <ArticleLayout
      title={get(commonContent, 'title', '')}
      placeholder={get(commonContent, 'search_placeholder', '')}
      searchtext={searchtext}
    >
      <div className="container">
        <Row justify="center">
          <Col xs={22} md={22} xl={16}>
            <Row justify="space-between" className="search__resultHeader">
              <h3 className="title">{searchtext}</h3>
              <div className="subtitle">
                <span className="highlight">{flatten(searchContent).length}</span> results found
              </div>
            </Row>
            {map(flatten(searchContent), (v, key) => (
              <Row justify="center" key={key}>
                <SearchItem
                  searchtext={searchtext}
                  categoryName={v.title ? get(v, 'title', '') : get(v, 'label', '')}
                  slugs={get(v, 'mergeSlug', '').split('/')}
                  detail={get(v, 'modDetail', '')}
                  onClick={() => handleOnClick(get(v, 'mergeSlug', ''))}
                />
              </Row>
            ))}
          </Col>
        </Row>
      </div>
    </ArticleLayout>
  )
}

export default SearchResult
